module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-10.bfe0eefe.png";